import '../landing.css';
import banner from 'assets/images/landing/CANADA_Membership_Banner.png';

const Rest = () => (
    <div id="content">
        <div>
            <section id="primary" className="content-area pt-3">
                <Membership />
                <ProvincialOrganizations />
                <MembershipInfo />
            </section>
        </div>
    </div>
);

const Membership = () => (
    <main
        id="main"
        role="main"
        style={{
            padding: '0',
            border: 'none',
            background: '#ffffff',
            textAlign: 'center',
            color: '#000',
        }}
    >
        <img
            src={banner} // Replace this with the actual image URL or import
            alt="Membership Banner"
            style={{
                width: '100%',
                maxWidth: '1200px', // Increased max-width
                display: 'block',
                margin: '0 auto',
                marginBottom: '20px',
            }}
        />
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            maxWidth: '1200px',
            margin: '0 auto',
            marginBottom: '20px'
        }}>
            <Button
                href="/join"
                text="MEMBER JOIN"
                style={{
                    flex: '1',
                    borderRadius: '0',
                }}
            />
            <Button
                href="/login"
                text="MEMBER LOGIN"
                style={{
                    flex: '1',
                    borderRadius: '0',
                }}
            />
            <Button
                href="#membership-benefits"
                text="MEMBERSHIP BENEFITS"
                style={{
                    flex: '1',
                    borderRadius: '0'
                }}
            />
        </div>
    </main>
);

interface ButtonProps {
    href: string;
    text: string;
    onClick: Function;
}

const Button = ({ href, text, onClick }: ButtonProps) => (
    <a
        onClick={onClick}
        href={href}
        className="btn btn-danger rounded-pill py-3 px-5"
        style={{
            fontSize: '24px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            minWidth: '250px',
            cursor: 'pointer'
        }}
    >
        <b>{text}</b>
    </a>
);

const organizations = [
    {
        link: 'https://wswbc.org/',
        image: '/wsbc-logo.png'
    },
    {
        link: 'http://www.wswa.ca/',
        image: '/wswa-logo.png'
    },
    {
        link: 'https://www.wswsask.ca/',
        image: '/wswsask-logo.png'
    },
    {
        link: 'http://www.wswm.ca/',
        image: '/wswm-logo.png'
    },
    {
        link: 'https://www.wswo.ca/',
        image: '/wswo-logo.png'
    },
    {
        image: '/wsqb-logo.png'
    },
    {
        link: 'https://waterskiwakeboardnovascotia.com/',
        image: '/wswns-logo.png'
    }
];

const ProvincialOrganizations = () => (
    <main
        id="main"
        className="site-main container text-center mb-3"
        role="main"
        style={{ padding: '50px 0', backgroundColor: '#c4c4c2' }}
    >
        <h1 style={{ textAlign: 'center', fontSize: '36px', fontWeight: 'bold', textTransform: 'uppercase', margin: '0 0 30px 0' }}>
            Our Provincial Organizations
        </h1>
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'space-around',
                alignItems: 'center',
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '0 15px'
            }}
        >
            {organizations.map((org, index) => (
                <div key={index} style={{ flex: '0 0 auto', padding: '0 10px' }}>
                    {org.link ? (
                        <a href={org.link} target="_blank" rel="noopener noreferrer">
                            <div
                                style={{
                                    background: `url(${org.image}) center center / contain no-repeat`,
                                    width: '120px',
                                    height: '120px'
                                }}
                            ></div>
                        </a>
                    ) : (
                        <div
                            style={{
                                background: `url(${org.image}) center center / contain no-repeat`,
                                width: '120px',
                                height: '60px'
                            }}
                        ></div>
                    )}
                </div>
            ))}
        </div>
    </main>
);

const MembershipInfo = () => {
    const partnerLogos = [
        { name: "Shuswap Ski and Board", image: "/shuswap.png", link: "https://www.shuswapskiandboard.com" },
        { name: "Petro-Canada", image: "/petrocanada.png", link: "https://www.petro-canada.ca" },
        { name: "Lloyd Sadd Navacord", image: "/lloydsadd_navacord.png", link: "https://www.lloydsadd.com" },
        { name: "Canadian Athlete Insurance Program (CAIP)", image: "/caip.png" },
        { name: "Perkopolis", image: "/Perkopolis.png", link: "https://www.perkopolis.com" },
        { name: "Corporate Traveller", image: "/corporate_traveller.png", link: "https://www.corporatetraveller.ca" },
        { name: "Enterprise", image: "/enterprise.png", link: "https://www.enterprise.ca" },
        { name: "Coach.ca", image: "/coach_ca.png", link: "https://coach.ca" }
    ];

    return (
        <main id="main" className="site-main container mb-3 text-center" role="main" style={{ padding: '100px 30px', background: 'white' }}>
            {/* Main Header Section */}
            <h1 style={{ fontSize: '42px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>
                Water Ski and Wakeboard Canada Membership System
            </h1>

            <p style={{ fontSize: '22px', lineHeight: '1.6', textAlign: 'center', maxWidth: '900px', margin: '0 auto' }}>
                Sign up for a Water Ski and Wakeboard Canada Membership with our New Membership<br />
                System to be able to participate in our events, clinics and tournaments for any of our<br />
                <strong>Disciplines:</strong>  water ski, wakeboard, wakesurf, show ski, adaptive, barefoot<br /><br />
                <strong>Adult Membership - $50</strong><br />
                This Annual Adult Membership is for athletes, coaches, officials who can participate or<br />
                compete in Towed Water Sports Tournaments/Events. These members can also<br />
                participate in Officials and Coaches Education Clinics. This membership is for those<br />
                members who are 18+ years of age.
                <br /><br />
                <strong>Youth Membership - $40</strong><br />
                This Annual Youth Membership is for athletes, coaches, officials who can participate or compete in Towed Water Sports Tournaments/Events. These
                members can also participate in Officials and Coaches Education Clinics. This membership is for those members who are younger than 18 years of age.
                <br /><br />
                <strong>Supporter/Volunteer Membership - $15</strong><br />
                This Annual Membership is for those members who volunteer or support our Events, Tournaments, Camps or Clinics. This membership is for those members who are any age.

            </p>

            <div className="py-5 w-100">
                <hr
                    style={{
                        width: '30%',
                        borderTop: '2px solid #000',
                        margin: '0 auto'
                    }}
                />
            </div>

            {/* 2025 Membership Section */}
            <h1 style={{ fontSize: '42px', fontWeight: 'bold', marginBottom: '30px', textAlign: 'center', lineHeight: '1.4' }}>
                How to take out your 2025 Membership
            </h1>

            <p style={{ fontWeight: 'bold', fontSize: '26px', marginBottom: '15px', lineHeight: '1.5' }}>
                1.	Create your Account in the New System</p>
            <p style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '30px' }}>
                Each Member will use the <strong>MEMBER JOIN</strong> button <strong>first</strong> to create their<br />
                Membership Account in the New Membership System</p>

            <p style={{ fontWeight: 'bold', fontSize: '26px', marginBottom: '15px', lineHeight: '1.5' }}>
                2.	Renew Your Membership for 2025</p>
            <p style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '30px' }}>
                After your Membership Account has been created, each member will Renew their<br />
                Membership</p>

            <p style={{ fontWeight: 'bold', fontSize: '26px', marginBottom: '15px', lineHeight: '1.5' }}>
                3.	Pay for your Membership</p>
            <p style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '30px' }}>
                Once your Membership is renewed, follow the steps to Pay for your Membership.<br />
                Then your Membership will be <span className='active'>ACTIVE</span> </p>

            <p style={{ fontWeight: 'bold', fontSize: '26px', marginBottom: '15px', lineHeight: '1.5' }}>
                4.	Add dependents to membership account as required</p>
            <p style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '30px' }}>
                The next time a member goes into their Membership Account,<br />
                they will select the <strong>MEMBER LOGIN</strong> option.
            </p>

            <div className="py-5 w-100">
                <hr
                    style={{
                        width: '30%',
                        borderTop: '2px solid #000',
                        margin: '0 auto'
                    }}
                />
            </div>

            {/* MEMBERSHIP BENEFITS */}
            <h1 id="membership-benefits" style={{ fontSize: '42px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center', lineHeight: '1.4' }}>
                MEMBERSHIP BENEFITS
            </h1>

            <div style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
                <p style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '20px', lineHeight: '1.5', textAlign: 'center' }}>
                    Receive numerous benefits including:
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '40px' }}>
                    <li style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '15px' }}>
                        Discounts to water sports industry partners like Shuswap Ski and Board
                    </li>
                    <li style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '15px' }}>
                        Discounts to hundreds of brands and services through our member benefits<br /> partner – Perkopolis
                    </li>
                    <li style={{ fontSize: '20px', lineHeight: '1.6', marginBottom: '15px' }}>
                        Regular water sports newsletters delivered directly to your email inbox
                    </li>
                </ul>
            </div>

            <div style={{ marginTop: '50px', marginBottom: '30px' }}>
                {/* First row of logos */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '30px',
                    marginBottom: '30px'
                }}>
                    {partnerLogos.slice(0, 4).map((partner, index) => (
                        <a
                            key={index}
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'block', maxWidth: '180px' }}
                        >
                            <img
                                src={partner.image}
                                alt={partner.name}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    maxHeight: '120px',
                                    objectFit: 'contain'
                                }}
                            />
                        </a>
                    ))}
                </div>

                {/* Second row of logos */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '30px'
                }}>
                    {partnerLogos.slice(4).map((partner, index) => (
                        <a
                            key={index}
                            href={partner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ display: 'block', maxWidth: '180px' }}
                        >
                            <img
                                src={partner.image}
                                alt={partner.name}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    maxHeight: '120px',
                                    objectFit: 'contain'
                                }}
                            />
                        </a>
                    ))}
                </div>
            </div>

            <div className="py-5 w-100">
                <hr
                    style={{
                        width: '30%',
                        borderTop: '2px solid #000',
                        margin: '0 auto 40px'
                    }}
                />
            </div>

            {/* Support buttons section */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                marginBottom: '50px'
            }}>
                <a href="/NewMembershipSystemQuickSupportGuide.pdf" target="_blank" rel="noopener noreferrer" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    width: '300px',
                    height: '160px',
                    borderRight: '1px solid #000',
                    textDecoration: 'none',
                    color: '#000',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '22px',
                    lineHeight: '1.4',
                    backgroundColor: '#fff'
                }}>
                    MEMBERSHIP SUPPORT<br />
                    QUICK PDF SUMMARY
                </a>
                <a href="/NewMembershipSystemHowtoVideo.mp4" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    width: '300px',
                    height: '160px',
                    borderRight: '1px solid #000',
                    textDecoration: 'none',
                    color: '#000',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '22px',
                    lineHeight: '1.4',
                    backgroundColor: '#fff'
                }}>
                    MEMBERSHIP<br />
                    SUPPORT<br />
                    DETAILED VIDEO
                </a>
                <a href="/NewMembershipSystemDetailedGuide.pdf" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    width: '300px',
                    height: '160px',
                    borderRight: '1px solid #000',
                    textDecoration: 'none',
                    color: '#000',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '22px',
                    lineHeight: '1.4',
                    backgroundColor: '#fff'
                }}>
                    MEMBERSHIP<br />
                    SUPPORT<br />
                    DETAILED PDF GUIDE
                </a>
            </div>

            {/* Contact information section */}
            <div style={{ marginBottom: '50px', textAlign: 'center' }}>
                <p style={{ fontSize: '26px', marginBottom: '10px' }}>
                    FOR MORE INFORMATION AND SUPPORT
                </p>
                <p style={{ fontSize: '26px' }}>
                    EMAIL: <a href="mailto:membership@wswc.ca" style={{ fontWeight: 'bold', color: '#000', textDecoration: 'none' }}>membership@wswc.ca</a>
                </p>
            </div>
        </main>
    );
};

export default Rest;
